import { css } from "@emotion/react";
import { media } from "styles/breakpoints";

export const MemberVipPageStyle = {
  wrapper: css`
    padding: 0;

    ${media.md} {
      padding: 0 16px;
    }
  `
};
